import { Slice, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

export type FinanceDashboadSliceStateType = {

    dateFilter: {
        startDate: string | null;
        endDate: string | null;
    };

    quarter: any
    quarterYear: string

    dateFilterCashflow: {
        startDate: string | null;
        endDate: string | null;
    };
    cashflowQuarter: any
    cashflowQuarterYear: string

};

const initialState: FinanceDashboadSliceStateType = {

    dateFilter: {
        startDate: moment().startOf('year').format('YYYY-MM'), // January of the current year
        endDate: moment().endOf('year').format('YYYY-MM'),   // December of the current year
    },

    quarter: [],
    quarterYear: '',
    dateFilterCashflow: {
        startDate: '',
        endDate: '',
    },
    cashflowQuarter: [],
    cashflowQuarterYear: ''

};

const FinanceDashboadSlice: Slice<FinanceDashboadSliceStateType> = createSlice({
    name: "financeDashboad",
    initialState,
    reducers: {
        setDateFilter: (state, action: PayloadAction<{ startDate: string; endDate: string }>) => {
            state.dateFilter = action.payload;
        },
        setQuarter: (state, action: PayloadAction<any[] | []>) => {
            state.quarter = action.payload;
        },
        setQuarterYear: (state, action: PayloadAction<string>) => {
            state.quarterYear = action.payload;
        },
        setCashflowDateFilter: (state, action: PayloadAction<{ startDate: string; endDate: string }>) => {
            state.dateFilterCashflow = action.payload;
        },
        setCashflowQuarter: (state, action: PayloadAction<any[] | []>) => {
            state.cashflowQuarter = action.payload;
        },
        setCashflowQuarterYear: (state, action: PayloadAction<string>) => {
            state.cashflowQuarterYear = action.payload;
        },
    },
});

export const {
    setDateFilter,
    setQuarter,
    setQuarterYear,
    setCashflowDateFilter,
    setCashflowQuarter,
    setCashflowQuarterYear,

} = FinanceDashboadSlice.actions;
export default FinanceDashboadSlice.reducer;